import axios from 'axios';

const getMessages = params => axios.get('/mensagens', { params });

export default {
  getMessages,
};
